export const RECORD_REQUEST_SET_PROVIDER = 'RECORD_REQUEST_SET_PROVIDER' as const;
export const RECORD_REQUEST_SET_PATIENT = 'RECORD_REQUEST_SET_PATIENT' as const;
export const RECORD_REQUEST_SET_DATE = 'RECORD_REQUEST_SET_DATE' as const;
export const RECORD_REQUEST_SET_AUTHORIZATION = 'RECORD_REQUEST_SET_AUTHORIZATION' as const;
export const RECORD_REQUEST_SET_GOVT_ID = 'RECORD_REQUEST_SET_GOVT_ID' as const;
export const RECORD_REQUEST_SET_SUPPORTING_DOCS = 'RECORD_REQUEST_SET_SUPPORTING_DOCS' as const;
export const RECORD_REQUEST_SET_PAYMENT_METHOD = 'RECORD_REQUEST_SET_PAYMENT_METHOD' as const;
export const RECORD_REQUEST_SET_PAYMENT = 'RECORD_REQUEST_SET_PAYMENT' as const;
export const RECORD_REQUEST_RESET = 'RECORD_REQUEST_RESET' as const;
export const RECORD_REQUEST_LOADING = 'RECORD_REQUEST_LOADING' as const;
export const RECORD_REQUEST_SET_CARD_NUMBER = 'RECORD_REQUEST_SET_CARD_NUMBER' as const;
export const RECORD_REQUEST_SET_CARD_TYPE = 'RECORD_REQUEST_SET_CARD_TYPE' as const;
export const RECORD_REQUEST_SET_PROVIDER_NAME = 'RECORD_REQUEST_SET_PROVIDER_NAME' as const;
export const RECORD_REQUEST_SET_REQUEST_ID = 'RECORD_REQUEST_SET_REQUEST_ID' as const;
export const RECORD_REQUEST_FAILURE = 'RECORD_REQUEST_FAILURE' as const;
export const RECORD_REQUEST_PATIENT_INFO = 'RECORD_REQUEST_PATIENT_INFO' as const;
export const RECORD_REQUEST_SET_REQUEST_DETAILS = 'RECORD_REQUEST_SET_REQUEST_DETAILS' as const;
export const RECORD_REQUEST_SET_AUTH_TYPE = 'RECORD_REQUEST_SET_AUTH_TYPE' as const;
export const RECORD_REQUEST_SET_ESTIMATE_AUTH = 'RECORD_REQUEST_SET_ESTIMATE_AUTH' as const;
export const RECORD_REQUEST_SET_SHOW_PROMPT = 'RECORD_REQUEST_SET_SHOW_PROMPT' as const;
export const RECORD_REQUEST_SET_RID = 'RECORD_REQUEST_SET_RID' as const;
export const RECORD_REQUEST_DELETE_SUPPORTING_DOC = 'RECORD_REQUEST_DELETE_SUPPORTING_DOC' as const;

